module.exports = __webpack_public_path__ + "static/media/Green.d7c0ca04.svg";